export const chartColors = ['#29889B', '#1F95FA', '#F8942D', '#5C4585', '#EC7782', '#AFCB66', '#C2996F']
export const darkerChartColors = ['#1F6B7A', '#176FC8', '#C76F1F', '#453366', '#B35C66', '#8AA34D', '#946F54']
export const emptyColors = ['#999999', '#CCCCCC', '#DDDDDD', '#EEEEEE']
export const expiredColors = ['#29889B', '#EEEEEE']
export const othersColor = '#636363'
export const emptyColor = '#F4F4F5'

// https://www.figma.com/design/zRcxwyam12g3iRYjg4qrCl/ShadCN-%7C-MYA-Redesign?node-id=5865-13861&p=f&t=OqQZmm3HrR3YT Distinct Color Palette
export const assetsColors = ['#1E3A8A', '#3B82F6', '#60A5FA', '#6366F1', '#818CF8', '#A78BFA', '#C4B5FD']
export const liabilitiesColors = ['#B91C1C', '#DC2626', '#F87171', '#EA580C', '#F9731D', '#F59E0B', '#FCD34D']

interface TFunction {
  (key: string, options?: { defaultValue?: string }): string
}

export function defaultEmptyData4() {
  return [
    { label: '', value: 0, fill: emptyColor },
    { label: '', value: 0, fill: emptyColor },
    { label: '', value: 0, fill: emptyColor },
    { label: '', value: 0, fill: emptyColor }
  ]
}

export function defaultEmptyData2() {
  return [
    { label: '', value: 0, fill: emptyColor },
    { label: '', value: 0, fill: emptyColor }
  ]
}

export function defaultEmptyData1() {
  return [{ label: '', value: 0, fill: emptyColor }]
}

export function emptyData(t: TFunction) {
  return defaultEmptyData4()
  return [
    { label: t('AssetTypeOptions.Property'), value: 0, fill: emptyColor },
    { label: t('nav:finance'), value: 0, fill: emptyColor },
    { label: t('AssetTypeOptions.OtherCollectables'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyFinanceData(t: TFunction) {
  return defaultEmptyData4()
  return [
    { label: t('AssetTypeOptions.CashAndBanking'), value: 0, fill: emptyColor },
    { label: t('AssetTypeOptions.OtherInvestment'), value: 0, fill: emptyColor },
    { label: t('AssetTypeOptions.Insurance'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyCashAndBankingData(t: TFunction) {
  return defaultEmptyData4()
  return [
    { label: t('finances:AccountType.Cash'), value: 0, fill: emptyColor },
    { label: t('finances:AccountType.CreditCardAccount'), value: 0, fill: emptyColor },
    { label: t('finances:AccountType.CurrentAccount'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyCollectablesData(t: TFunction) {
  return defaultEmptyData4()
  return [
    { label: t('AssetTypeOptions.Art'), value: 0, fill: emptyColor },
    { label: t('AssetTypeOptions.WineAndSpirits'), value: 0, fill: emptyColor },
    { label: t('AssetTypeOptions.OtherCollectables'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyOtherInvestmentData(t: TFunction) {
  return defaultEmptyData4()
  return [
    { label: t('finances:InvestmentTypeOptions.Loan'), value: 0, fill: emptyColor },
    { label: t('finances:InvestmentTypeOptions.Share'), value: 0, fill: emptyColor },
    { label: t('finances:InvestmentTypeOptions.Warrant'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyPropertyData(t: TFunction) {
  return defaultEmptyData4()
  return [
    { label: t('properties:PropertyTypeOptions.House'), value: 0, fill: emptyColor },
    { label: t('properties:PropertyTypeOptions.Bungalow'), value: 0, fill: emptyColor },
    { label: t('properties:PropertyTypeOptions.Cabin'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyOwnershipData(t: TFunction) {
  return defaultEmptyData1()
  return [
    { label: t('Person'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyBelongingData(t: TFunction) {
  return defaultEmptyData2()
  return [
    { label: t('AssetTypeOptions.Belonging'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyArtData(t: TFunction) {
  return defaultEmptyData2()
  return [
    { label: t('AssetTypeOptions.Art'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
export function emptyWineData(t: TFunction) {
  return defaultEmptyData2()
  return [
    { label: t('AssetTypeOptions.WineAndSpirits'), value: 0, fill: emptyColor },
    { label: t('Others'), value: 0, fill: emptyColor }
  ]
}
